'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import * as React from 'react';
import type { Option } from './multiselect';
interface OverflowRendererProps {
  overflowItems: Option[];
  badgeClassName?: string;
}
function OverflowRenderer(t0) {
  const $ = _c(5);
  const {
    overflowItems,
    badgeClassName
  } = t0;
  let t1;
  if ($[0] !== badgeClassName) {
    t1 = cn("bg-background text-secondary-foreground relative inline-flex h-7 shrink-0 cursor-default items-center rounded-md border px-2 text-xs font-medium", badgeClassName);
    $[0] = badgeClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== overflowItems.length || $[3] !== t1) {
    t2 = <div className={t1}>+{overflowItems.length}</div>;
    $[2] = overflowItems.length;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { OverflowRenderer };